<template>
  <div class="leftCenter">
    <div class="title" :class="menuItem.ecPlatformTransRank ? 'setCursor' : ''" @click="showModel">电商平台</div>
    <div class="list">
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-dpzs.png' />
        <div class="text">店铺总数</div>
        <div class="num">{{ summary.shopQuantity || 0  }}<span>个</span></div>
      </div>
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-jyze.png' />
        <div class="text">交易总额</div>
        <div class="num">{{ summary.tradeTotal || 0  }}<span>万</span></div>
      </div>
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-ddze.png' />
        <div class="text">订单笔数</div>
        <div class="num">{{ summary.orderQuantity || 0  }}<span>笔</span></div>
      </div>
    </div>
    <div id="leftCenter-charts"></div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const { mapState, mapMutations } = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        ecPlatformTransRank: true // 电商平台交易额TOP排名
      },
      formData: {},
      topSummary: {
      },
      summary: {
        shopQuantity: 0,
        tradeTotal: 0,
        orderQuantity: 0
      },
      myChart: null, // 图表对象
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.ecPlatformTransRank = common.isShowItem('ecPlatformTransRank', setListMenu)
    }
  },

  mounted () {
    var chartDom = document.getElementById('leftCenter-charts')
    this.myChart = this.$echarts.init(chartDom)
    this.init()
    this.initObj = setInterval(() => {
      this.init()
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    init () {
      this.getDataSummary()
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.getOrderStatistics}`,
        parmas: {
          pageIndex: 1,
          pageSize: 10
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data || []
          this.topSummary = dataInfo || []
        }
        this.initCharts()
      })
    },
    getDataSummary () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.getDataSummary.getDataSummary}`,
        parmas: {
          pageIndex: 1,
          pageSize: 10,
          yearTime: this.homeTime
        }
      }).then(res => {
        this.summary.shopQuantity = res.data.storesNum || 0
        this.summary.tradeTotal = (res.data.transaction / 10000).toFixed(2) || 0
        this.summary.orderQuantity = res.data.orderNum || 0
      })
    },
    // 设置语言文字
    initCharts () {
      this.myChart && this.myChart.clear()
      let nums = this.topSummary.map(item => { return item.orderNum })
      let tradeTotal = this.topSummary.map(item => { return (item.transaction / 10000).toFixed(2) })
      let names = this.topSummary.map(item => { return item.platform })
      var option
      const colors = ['#5470C6', '#EE6666']
      option = {
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          top: '15%',
          left: '15%',
          right: '0%',
          bottom: '15%'
        },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        legend: {
          data: ['交易额(万)', '订单数量'],
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            label: {
              // 柱图头部显示值
              show: true,
              position: 'top',
              color: '#ffffff',
              fontSize: '10px',
              textStyle: {
                color: '#ffffff',
                fontSize: 12
              }
            },
            // prettier-ignore
            data: names
          }
        ],
        yAxis: [
          {
            show: true,
            type: 'value',
            position: 'left',
            alignTicks: true,
            axisLabel: {
              textStyle: {
                color: '#ffffff'
              }
            },
            data: nums,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            }
          },
          {
            type: 'value',
            name: '',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: ``
            }
          }
        ],
        series: [
          {
            name: '交易额(万)',
            type: 'bar',
            data: tradeTotal,
            barWidth: 16,
            itemStyle: {
              normal: {
                color: function (parmas) {
                  let colorList = ['#73C0DE', '#EE6666', '#5470C6', '#91CC75', '#FAC858', '#2890EC', '#73C0DE', '#EE6666', '#5470C6', '#91CC75', '#FAC858', '#2890EC']
                  return colorList[parmas.dataIndex]
                }
              }
            },
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#111'
              }
            },
            label: {
              // 柱图头部显示值
              show: true,
              position: 'top',
              color: '#ffffff',
              fontSize: '10px',
              textStyle: {
                color: '#ffffff',
                fontSize: 12
              },
              formatter: '{c}' + '万'
            }

          },
          {
            name: '订单数量',
            type: 'line',
            yAxisIndex: 1,
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            data: nums
          }
        ]
        // grid: {
        //   left: 0,
        //   right: 0,
        //   bottom: 0,
        //   top: 0,
        //   containLabel: true
        // },
      }
      option && this.myChart.setOption(option)
    },
    showModel () {
      if (!this.menuItem.ecPlatformTransRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'getIntegrationPlatformPage',
        title: '电商平台交易额TOP排名',
        method: 'post',
        headList: [
          {
            name: '店铺总数',
            value: that.summary.shopQuantity,
            unit: '（家）'
          }, {
            name: '交易总额',
            value: that.summary.tradeTotal,
            unit: '（万）'
          }, {
            name: '订单量',
            value: that.summary.orderQuantity,
            unit: '（笔）'
          }
        ],
        model: true
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
.leftCenter {
  width: 454px;
  height: 281px;
  background: url('~@/assets/images/home/title-bg.png') no-repeat 0 0;
  background-size: 100% 100%;

  .title {
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #00FAFF;
    width: 100%;
    line-height: 18px;
    margin-top: 16px;
    text-align: center;
  }

  .list {
    display: flex;
    justify-content: space-between;
    margin: 12px 18px 0 18px;

    .item {
      display: flex;
      align-items: center;
      white-space: nowrap;

      .icon {
        width: 34px;
        height: 34px;
      }

      .text {
        font-size: 10px;
      }

      .num {
        font-size: 14px;
        color: #30FDFF;

        span {
          font-size: 10px;
        }
      }
    }
  }

  #leftCenter-charts {
    margin: 16px 18px 0 18px;
    width: 420px;
    height: 176px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/leftCenter.vue